// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"72fb19db","239":"60b05a41","455":"7ee093de"}[chunkId] + ".chunk.js";
};